import { render } from "./TheButton.vue?vue&type=template&id=ae30c852&scoped=true"
import script from "./TheButton.vue?vue&type=script&lang=js"
export * from "./TheButton.vue?vue&type=script&lang=js"

import "./TheButton.vue?vue&type=style&index=0&id=ae30c852&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae30c852"]])

export default __exports__